import { Link } from 'react-router-dom';

import { LoadingSpinner } from '@app/shared/ui/atoms/Common';
import { formatNumber } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { PriceType } from '@app/shared/types/common';
import { cookieImage, diamondIcon } from '@app/assets';
import { useBalance } from '@app/shared/hooks/useBalance';

interface HeaderBalanceProps {
  type: PriceType;
  balance?: string;
  isLoading: boolean;
  id?: string;
  onClick?: () => void;
}

const HEADER_BALANCE = {
  cookie: {
    url: Page.COOKIES_SHOP,
    zeroBalanceUrl: Page.COOKIES_SHOP,
    classNames: 'border-orange-500 bg-[#ffecb6] text-orange-500',
    spinnerVariant: 'orange',
    image: cookieImage,
    alt: 'cookie',
  },
  ton: {
    url: Page.DIAMONDS_SHOP,
    zeroBalanceUrl: Page.SETTLEMENTS_SHOP,
    classNames: 'border-accent bg-[#EAF5FA] text-accent',
    spinnerVariant: 'accent',
    image: diamondIcon,
    alt: 'diamond',
  },
} as const;

export function HeaderBalanceLink({ type, balance, isLoading, id, onClick }: HeaderBalanceProps) {
  const link = HEADER_BALANCE[type];
  const { tonBalance } = useBalance();

  const destination = type === PriceType.TON && tonBalance <= 0 ? link.zeroBalanceUrl : link.url;

  return (
    <Link
      to={destination}
      id={id}
      className={`flex h-8 items-center gap-[5px] rounded-[5px] border p-1 xs:p-2 md:p-[14px] ${link.classNames}`}
      onClick={onClick}
    >
      {isLoading ? (
        <LoadingSpinner variant={link.spinnerVariant} size="xs" />
      ) : (
        <span className="font-inter xs:text-xs font-semibold tracking-tight sm:text-sm">
          {formatNumber(balance ?? 0)}
        </span>
      )}
      <img src={link.image} alt={link.alt} className="size-3 object-contain xs:size-4" />
    </Link>
  );
}
